import { Box, ListItemIcon, ListItemText, ListSubheader, ListItem, List, styled, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { Option } from './DropdownController';

type Props<T> = {
  title: string;
  currentValue: Option<T>['value'];
  options: Option<T>[];
  onSelect: (value: T) => void;
};

const DropdownItem = styled(ListItem)(({ theme }) => ({
  backgroundColor: theme.palette.primary.dark,
  color: theme.palette.primary.contrastText,
  padding: '8px 32px 8px 16px',
  '&:not(.nohover):hover': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  '&.Mui-disabled': {
    opacity: 1,
  },
}));

export const Dropdown = <T extends string | number>({ title, options, currentValue, onSelect }: Props<T>) => {
  return (
    <Box display="flex" justifyContent="flex-end" overflow="hidden" maxHeight="80%">
      <Box
        sx={({ palette }) => ({
          backgroundColor: palette.primary.dark,
          opacity: 0.8,
          marginBottom: '12px',
          borderRadius: '8px',
        })}
      >
        <List
          sx={{ overflow: 'auto', height: '100%', borderRadius: '8px' }}
          subheader={
            <ListSubheader
              sx={{
                backgroundColor: 'inherit',
                padding: 0,
                width: '100%',
              }}
              component="div"
            >
              <DropdownItem className="nohover">
                <Typography variant="p16Medium">{title}</Typography>
              </DropdownItem>
            </ListSubheader>
          }
        >
          {options.map(option => {
            const { label, value } = option;
            return (
              <DropdownItem key={value} onClick={() => onSelect(option.value)}>
                <ListItemIcon sx={{ minWidth: '32px' }}>
                  {value === currentValue && <CheckIcon color="secondary" />}
                </ListItemIcon>
                <ListItemText>{label ?? value}</ListItemText>
              </DropdownItem>
            );
          })}
        </List>
      </Box>
    </Box>
  );
};
